import { Header } from "antd/es/layout/layout";
import { formatAuthor } from "../../composants/utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Badge, Button, Dropdown, Space } from "antd";
import { 
    faBars, 
    faClose, 
    faUser, 
    faSignOutAlt,
    faBell,
    faGraduationCap,
    faChevronDown
} from "@fortawesome/free-solid-svg-icons";
import { CollepsedContext } from "../../configurations/context/collepsedContext";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { ColorsContext } from "../../configurations/context/colorContext";

export const CustomHeader = () => {
    const {collespsed, setCollespsed} = useContext(CollepsedContext);
    const {colors} = useContext(ColorsContext);
    const {user, droits} = useSelector(state => state.authUser);
    
    
            const menuProps = {
                items: [
                    {
                        label: (
                            <div className="px-4 py-3 border-b border-gray-100">
                                <div className="flex items-center gap-3">
                                    <Avatar size={40} src={user?.photo==null ? '/images/profile-img.jpg' : user?.photo} />
                                    <div>
                                        <div className="text-sm font-semibold text-gray-900" title={(user===null) ? "" : user?.prenom + ' '+ user?.nom}>
                                            {(user===null) ? "" : user?.prenom + ' ' + user?.nom}
                                        </div>
                                        <div className="text-xs text-gray-500">
                                            Étudiant YOUTHFP
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        key: '0',
                    },
                    {
                        label: (
                            <div className="flex items-center gap-3 px-2 py-2 hover:bg-gray-50 rounded-lg transition-colors">
                                <FontAwesomeIcon icon={faUser} className="text-gray-500" />
                                <span className="text-gray-700">Mon Profil</span>
                            </div>
                        ),
                        key: '1',
                        onClick: () => {
                            // Redirection vers profil
                        }
                    },                
                    {
                        type: 'divider',
                    },
                    {
                        label: (
                            <div className="flex items-center gap-3 px-2 py-2 hover:bg-red-50 rounded-lg transition-colors" onClick={()=>{
                                window.location.href='/login';
                            }}>
                                <FontAwesomeIcon icon={faSignOutAlt} className="text-red-500" />
                                <span className="text-red-600 font-medium">Déconnexion</span>
                            </div>
                        ),
                        key: '4',
                    },
                ],
            };
    return (
        <Header 
            className="sticky top-0 z-50 p-0 shadow-lg backdrop-blur-sm border-b border-gray-200" 
            style={{
                background: `linear-gradient(135deg, ${colors.COLOR_HEADER} 0%, rgba(255,255,255,0.95) 100%)`,
                backdropFilter: 'blur(10px)'
            }}
        >
            <nav className="h-full">
                <div className="flex items-center justify-between h-full px-4 lg:px-6">
                    {/* Left Section - Menu Toggle */}
                    <div className="flex items-center gap-4">
                        <Button 
                            type="text" 
                            icon={
                                <FontAwesomeIcon 
                                    icon={collespsed ? faBars : faClose} 
                                    className="text-lg transition-transform duration-300 hover:scale-110" 
                                />
                            }
                            onClick={() => setCollespsed(!collespsed)}
                            className="w-12 h-12 text-gray-700 hover:bg-white/20 border-none shadow-none rounded-xl transition-all duration-300 hover:shadow-md"
                        />
                        
                        {/* Logo/Title Section */}
                        <div className="hidden md:flex items-center gap-3">
                            <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-blue-500 rounded-xl flex items-center justify-center shadow-lg">
                                <FontAwesomeIcon icon={faGraduationCap} className="text-white text-lg" />
                            </div>
                            <div>
                                <h1 className="text-xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                                    YouthFP E-Learning
                                </h1>
                                <p className="text-xs text-gray-500 -mt-1">Plateforme de formation</p>
                            </div>
                        </div>
                    </div>

                    {/* Center Section - Mobile Title */}
                    <div className="md:hidden flex-1 text-center">
                        <h1 className="text-lg font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                            YouthFP
                        </h1>
                    </div>

                    {/* Right Section - User Menu */}
                    <div className="flex items-center gap-3">
                        {/* Notification Badge */}
                        <Button 
                            type="text" 
                            icon={<FontAwesomeIcon icon={faBell} className="text-lg" />}
                            className="w-10 h-10 text-gray-600 hover:bg-white/20 border-none rounded-xl transition-all duration-300 hover:shadow-md hidden sm:flex items-center justify-center"
                        />

                        {/* User Dropdown */}
                        <Dropdown 
                            menu={menuProps} 
                            trigger={['click']}
                            placement="bottomRight"
                            overlayClassName="custom-dropdown"
                        >
                            <div className="flex items-center gap-3 px-3 py-2 hover:bg-white/20 rounded-xl transition-all duration-300 cursor-pointer group">
                                <Badge dot status="success" offset={[-2, 2]}>
                                    <Avatar 
                                        size={40} 
                                        src={user?.photo==null ? '/images/profile-img.jpg' : user?.photo}
                                        className="ring-2 ring-white/50 shadow-lg"
                                    />
                                </Badge>
                                <div className="hidden lg:block text-left">
                                    <div className="text-sm font-semibold text-gray-700 group-hover:text-gray-900 transition-colors">
                                        {user?.prenom || 'Utilisateur'}
                                    </div>
                                    <div className="text-xs text-gray-500">
                                        En ligne
                                    </div>
                                </div>
                                <FontAwesomeIcon 
                                    icon={faChevronDown} 
                                    className="text-gray-500 text-xs group-hover:text-gray-700 transition-all duration-300 group-hover:rotate-180 hidden lg:block" 
                                />
                            </div>
                        </Dropdown>
                    </div>
                </div>
            </nav>

            {/* Custom Dropdown Styles */}
            <style>{`
                .custom-dropdown .ant-dropdown-menu {
                    border-radius: 16px !important;
                    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
                    border: 1px solid #e5e7eb !important;
                    padding: 8px !important;
                    min-width: 280px !important;
                }
                
                .custom-dropdown .ant-dropdown-menu-item {
                    border-radius: 12px !important;
                    margin-bottom: 4px !important;
                    padding: 8px 12px !important;
                }
                
                .custom-dropdown .ant-dropdown-menu-item:hover {
                    background-color: #f3f4f6 !important;
                }
                
                .custom-dropdown .ant-dropdown-menu-item:last-child {
                    margin-bottom: 0 !important;
                }
            `}</style>
        </Header>
    );
}